<template>
    <button
        type="button"
        class="mixParlayToggle"
        v-bind:class="[{
            _active: isMixParlayMode,
            _euroSiteStyle: isEuroSite,
        }, ga]"
        v-on:click="switchMpMode"
    >
        <SvgIcon v-if="isEuroSite" iconName="sportIcon_multiple" />
        {{ getTranslationBySite('mix_parlay') }}
    </button>
</template>

<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import { BetSlipState, BetSlipType } from '@/interface/enum';
    import { useZone } from '@/libraries/composables/useZone';
    import { getTranslationBySite } from '@/libraries/helpers/i18nHelper';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useSingleModeBetSlipStore } from '@/stores/betSlip/singleModeBetSlipStore';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';
    import { useRootStore } from '@/stores/rootStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    const emits = defineEmits(['switchMpMode']);

    const { isMixParlayMode } = storeToRefs(useRootStore());
    const { isEuroSite } = storeToRefs(useFeatureToggleStore());
    const { swapWithLastBetSlip } = useBetSlipStore();
    const { isTournamentCenterZone } = useZone();
    const { betSlipType } = storeToRefs(useBetSlipStore());
    const { setBetSlipType, setBetSlipState } = useBetSlipStore();
    const { hasTickets } = storeToRefs(useSingleModeBetSlipStore());
    const { refreshAllTickets } = useSingleModeBetSlipStore();

    const ga = computed(() => {
        const prefix = isTournamentCenterZone.value ? 'TC_Matches' : 'JARVIS_MarketType';
        return `${prefix}_Btn_mixParlay`;
    });

    function switchMpMode() {
        emits('switchMpMode');

        swapWithLastBetSlip();

        if (betSlipType.value !== BetSlipType.SingleMode) {
            return;
        }
        if (!hasTickets.value) {
            setBetSlipType(BetSlipType.None);
            setBetSlipState(BetSlipState.Closed);
            return;
        }

        refreshAllTickets();
    }

</script>

<style lang="scss" scoped>
@import "@/scss/components/mixParlayToggle";
</style>
